<template>
  <div class="regist">
    <div class="re_header">
      <ul>
        <li><i class="cls-or left-row"></i>填写注册信息<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>邮箱验证<i class="el-icon-arrow-right"></i></li>
        <li class="active" v-if="isActive"><i class="el-icon-circle-check left-row"></i>注册成功</li>
        <li class="active" v-else><i class="el-icon-circle-close left-row"></i>注册失败</li>
      </ul>
    </div>
    <hr>
    <div class="message">
      <h2>用户注册</h2>
      <div class="sc-sendsed" v-if="isActive">
        恭喜: 账号已经成功激活，赶紧进行购物体验吧！
      </div>
      <div class="sc-sendsed" v-else>
        {{content}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'emali',
  data () {
    return {
      isActive: false,
      content: '稍等: 账号激活中。。。'
    }
  },
  created() {
    // 调用激活邮箱接口
    // 得到邮件标记
    let sign = {sign: this.$route.query.sign}
    this.sapost('/dmc/account/activeAccount', sign, r => {
      let {retCode, retMsg} = r.data
      if (retCode === '0') {
        this.isActive = true
      } else {
        this.$message.warning(retMsg)
        this.content = retMsg
      }
    })
  },
  methods: {

  }
}
</script>

<style lang="less">
.regist{
  width: 1100px;
  margin: 10px auto;
  min-height: 650px;
  .re_header{
    overflow: hidden;
    line-height: 55px;
    height: 55px;
    margin: 35px 0px;
    background-color: #f5f7fa;
    ul{
      overflow: hidden;
      li{
        float: left;
        width: 280px;
        padding-left: 80px;
        color: #c1c5cd;
        .cls-or{
          display: inline-block;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          box-shadow:0 0 0 1px #c0c4cc;
        }
        .left-row{
          margin-right: 10px;
        }
        .el-icon-arrow-right{
          float: right;
          line-height: 55px;
        }
      }
      .active{
        color: rgb(28, 203, 150);
        font-weight: 600;
      }
    }
  }
  hr{
    background-color: #f5f7fa;
    height: 2px;
    border: 0;
    margin-bottom: 30px;
  }
  .message{
    border: 3px solid #f5f7fa;
    border-radius: 5px;
    color: #818180;
    text-align: left;
    h2{
      padding-left: 25px;
      height: 45px;
      line-height: 45px;
      background-color:#f5f7fa;
    }
    .sc-sendsed{
      color: rgb(28, 203, 150);
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      padding:35px 0;
      margin: 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/saccount.vue